import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

/* ============================
   FETCH UPCOMING BOOKINGS
============================ */
export const fetchUpcomingBookings = createAsyncThunk(
  "bookings/fetchUpcoming",
  async ({ page = 1, limit = 20 }, { rejectWithValue }) => {
    try {
      const res = await api.get("api/payment/bookings/upcoming", {
        params: { page, limit },
      });
      return res.data.data; // { bookings, pagination }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to fetch bookings"
      );
    }
  }
);
